import apiClient from '../helpers/ApiClient'
import { handleError, authHeader } from '@/helpers/ApiClient';

export const invoiceService = {
    getInvoices, getDownloadInvoice, setInvoiceToPaid, setInvoiceToUnpaid, sendInvoiceReminder
}

function getInvoices(startDateString, endDateString)
{

    let startMs = new Date(startDateString).getTime();
    let endMs = new Date(endDateString).getTime();

    return apiClient.get("/invoice", {
            params: {startDate: startMs, endDate: endMs},
            headers: authHeader()
        }
    )
        .then((response) => {
            return response.data
        })
        .catch((error) => handleError(error));
}

function getDownloadInvoice(invoiceId) {
    return apiClient
        .get(`/invoice/${invoiceId}/download`,
            {
                headers: authHeader(),
            })
        .then((response) => {
            return response.data;
        })
        .catch((error) => handleError(error));
}

function setInvoiceToPaid(invoiceId) {
    return apiClient
        .post(`/invoice/${invoiceId}/paid`, {}, {
            headers: authHeader(),
        })
        .then((response) => {
            return response.data;
        })
        .catch((error) => handleError(error));
}

function setInvoiceToUnpaid(invoiceId) {
    return apiClient
        .post(`/invoice/${invoiceId}/unpaid`, {}, {
            headers: authHeader(),
        })
        .then((response) => {
            return response.data;
        })
        .catch((error) => handleError(error));
}

function sendInvoiceReminder(invoiceId) {
    return apiClient
        .post(`/invoice/${invoiceId}/reminder`, {}, {
            headers: authHeader(),
        })
        .then((response) => {
            return response.data;
        })
        .catch((error) => handleError(error));
}